import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { comics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function LatestUpdates() {
  const { t } = useTranslation();
  const latestComics = comics.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-16 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              {t('home.latestTitle')}
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              {t('home.latestSubtitle')}
            </p>
          </div>
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            {t('home.viewAll')}
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {latestComics.map((comic) => (
            <ComicCard
              key={comic.id}
              slug={comic.slug}
              title={comic.title}
              cover={comic.cover}
              category={comic.category}
              status={comic.status as 'ongoing' | 'completed'}
              rating={comic.rating}
              chaptersCount={comic.chapters.length}
            />
          ))}
        </div>
      </div>
    </section>
  );
}